import React from 'react';
import blogDetails from '../../components/singleblog/data';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer'
import {useLocation} from 'react-router';
import './post.css'

const Post = () => {
     const blog = blogDetails;
     const location = useLocation()
     const path = location.pathname.split('/')[2];
     const data = blog.find((p) => p.id.toString() === path);
    return (
        <div className='post'>
        <Navbar/>
        <div className='post-content'>
            <img className='post-img' src={data.img} alt=''/>
            <h1>{data.title}</h1>
            <p>{data.desc}</p>
            <img className='post-user' src={data.authorImg} alt=''/>
            <p>{data.authorName}</p>
        </div>
            <Footer/>
        </div>
    );
}

export default Post;
